import { useEffect, useState } from 'react';
import { SuperAdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

function CategoriesManager() {
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ nameDe: '', nameAl: '', icon: '' });
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () => api.get('/superadmin/categories').then(r => setCats(r.data.categories));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.nameDe || !form.nameAl) return setMsg('Name (DE + AL) pflichtfeld');
    setSaving(true);
    try {
      if (editId) {
        await api.put(`/superadmin/categories/${editId}`, form);
      } else {
        await api.post('/superadmin/categories', form);
      }
      setForm({ nameDe: '', nameAl: '', icon: '' });
      setEditId(null);
      await load();
      setMsg('');
    } catch (err) {
      setMsg(err.response?.data?.error || 'Fehler');
    } finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm('Kategorie wirklich löschen?')) return;
    try {
      await api.delete(`/superadmin/categories/${id}`);
      await load();
    } catch (err) {
      alert(err.response?.data?.error || 'Fehler');
    }
  };

  const startEdit = (c) => {
    setEditId(c.id);
    setForm({ nameDe: c.name_de, nameAl: c.name_al, icon: c.icon || '' });
  };

  return (
    <div className="card">
      <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 20 }}>
        Fragenkategorien
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
        {cats.map(c => (
          <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', background: 'var(--surface2)', borderRadius: 8 }}>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>{c.name_de}</span>
              <span style={{ color: 'var(--text3)', fontSize: 13, marginLeft: 10 }}>{c.name_al}</span>
              {!c.mosque_id && <span style={{ marginLeft: 8, fontSize: 10, background: '#DBEAFE', color: '#1D4ED8', borderRadius: 4, padding: '1px 6px', fontWeight: 700 }}>GLOBAL</span>}
              {c.mosque_id && <span style={{ marginLeft: 8, fontSize: 10, background: '#FEF3C7', color: '#92400E', borderRadius: 4, padding: '1px 6px', fontWeight: 700 }}>XHAMIA</span>}
            </div>
            <button className="btn btn-sm btn-ghost" onClick={() => startEdit(c)}>Bearbeiten</button>
            <button className="btn btn-sm btn-danger" onClick={() => del(c.id)}>Löschen</button>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto auto', gap: 8, alignItems: 'end' }}>
        <div>
          <label className="form-label" style={{ fontSize: 11 }}>Name Deutsch *</label>
          <input className="form-input" value={form.nameDe} onChange={e => setForm(p => ({ ...p, nameDe: e.target.value }))} placeholder="z.B. Islamische Ethik" />
        </div>
        <div>
          <label className="form-label" style={{ fontSize: 11 }}>Name Shqip *</label>
          <input className="form-input" value={form.nameAl} onChange={e => setForm(p => ({ ...p, nameAl: e.target.value }))} placeholder="p.sh. Etika Islame" />
        </div>
        <div>
          <label className="form-label" style={{ fontSize: 11 }}>Icon-Slug</label>
          <input className="form-input" style={{ width: 100 }} value={form.icon} onChange={e => setForm(p => ({ ...p, icon: e.target.value }))} placeholder="custom" />
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <button className="btn btn-primary" onClick={save} disabled={saving}>{editId ? 'Speichern' : '+ Hinzufügen'}</button>
          {editId && <button className="btn btn-ghost" onClick={() => { setEditId(null); setForm({ nameDe: '', nameAl: '', icon: '' }); }}>Abbrechen</button>}
        </div>
      </div>
      {msg && <p style={{ marginTop: 8, fontSize: 12, color: 'var(--error)' }}>{msg}</p>}
    </div>
  );
}

const FIELD_META = {
  company_name:       { label: 'Firmenname',            desc: 'Wird auf Rechnungen, E-Mails und PDFs verwendet' },
  company_slogan:     { label: 'Slogan / Beschreibung', desc: 'Untertitel unter dem Firmennamen auf Rechnungen' },
  company_address:    { label: 'Strasse / Hausnummer',    desc: 'Strassenzeile für Rechnungen und QR-Einzahlungsschein' },
  company_plz_city:   { label: 'PLZ und Ort',            desc: 'z.B. 8620 Wetzikon — für QR-Einzahlungsschein' },
  iban:               { label: 'IBAN',                   desc: 'Bankverbindung für den QR-Einzahlungsschein', mono: true },
  support_email:      { label: 'Support-E-Mail',         desc: 'Absender und Kontaktadresse für alle E-Mails' },
  trial_days:         { label: 'Testphase (Tage)',        desc: 'Kostenlose Testphase für neue Moscheen', type: 'number' },
  invoice_footer_de:  { label: 'Rechnungsfußzeile',      desc: 'Text am Ende jeder PDF-Rechnung', multi: true },
};

const PRICES = {
  standard_price_chf: { label: 'Standard-Preis CHF / Monat', type: 'number' },
  premium_price_chf:  { label: 'Premium-Preis CHF / Monat',  type: 'number' },
  standard_price_eur: { label: 'Standard-Preis EUR / Monat', type: 'number' },
  premium_price_eur:  { label: 'Premium-Preis EUR / Monat',  type: 'number' },
};

export default function SuperAdminSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [logoUploading, setLogoUploading] = useState(false);

  const uploadLogo = async (file) => {
    setLogoUploading(true);
    try {
      const fd = new FormData();
      fd.append('logo', file);
      const r = await api.post('/superadmin/settings/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSettings(p => ({ ...p, company_logo: r.data.logoUrl }));
      setMsg({ type: 'success', text: 'Logo hochgeladen' });
    } catch {
      setMsg({ type: 'error', text: 'Fehler beim Logo-Upload' });
    } finally {
      setLogoUploading(false);
    }
  };

  useEffect(() => {
    api.get('/superadmin/settings')
      .then(r => setSettings(r.data.settings || {}))
      .finally(() => setLoading(false));
  }, []);

  const set = (key, val) => setSettings(p => ({ ...p, [key]: val }));

  const save = async () => {
    setSaving(true);
    setMsg({ type: '', text: '' });
    try {
      await api.patch('/superadmin/settings', { settings });
      setMsg({ type: 'success', text: 'Einstellungen gespeichert' });
    } catch {
      setMsg({ type: 'error', text: 'Fehler beim Speichern' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <main className="main-content">
        <div className="page-header">
          <h1>Einstellungen</h1>
          <p>Systemweite Konfiguration für Ilmify</p>
        </div>

        {msg.text && (
          <div className={`alert alert-${msg.type === 'error' ? 'error' : 'success'}`} style={{ maxWidth: 720, marginBottom: 20 }}>
            {msg.text}
          </div>
        )}

        {loading ? <div className="spinner-wrap"><div className="spinner" /></div> : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24, maxWidth: 720 }}>

            {/* Logo */}
            <div className="card">
              <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 20 }}>
                Firmenlogo
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                {settings.company_logo ? (
                  <img src={settings.company_logo} alt="Logo" style={{ height: 48, maxWidth: 180, objectFit: 'contain', border: '1px solid var(--border)', borderRadius: 8, padding: 6, background: '#fff' }} />
                ) : (
                  <div style={{ width: 120, height: 48, border: '2px dashed var(--border)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text3)', fontSize: 12 }}>
                    Kein Logo
                  </div>
                )}
                <div>
                  <label className="btn btn-secondary" style={{ cursor: 'pointer', fontSize: 13 }}>
                    {logoUploading ? 'Hochladen...' : 'Logo hochladen'}
                    <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => e.target.files[0] && uploadLogo(e.target.files[0])} disabled={logoUploading} />
                  </label>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>PNG, JPG — erscheint oben auf der Rechnung</div>
                </div>
              </div>
            </div>

            {/* Company info */}
            <div className="card">
              <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 20 }}>
                Unternehmensdaten
              </h3>
              <div className="grid-2" style={{ gap: 16 }}>
                {['company_name', 'company_slogan', 'support_email', 'iban'].map(key => {
                  const m = FIELD_META[key];
                  return (
                    <div key={key} className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">{m.label}</label>
                      <input
                        className="form-input"
                        style={m.mono ? { fontFamily: 'monospace', letterSpacing: 1 } : {}}
                        value={settings[key] || ''}
                        onChange={e => set(key, e.target.value)}
                        placeholder={m.label}
                      />
                      <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>{m.desc}</div>
                    </div>
                  );
                })}
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label">Strasse / Hausnummer</label>
                  <input
                    className="form-input"
                    value={settings.company_address || ''}
                    onChange={e => set('company_address', e.target.value)}
                    placeholder="Musterstrasse 1"
                  />
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>Strassenzeile für Rechnungen und QR-Code</div>
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label">PLZ und Ort</label>
                  <input
                    className="form-input"
                    value={settings.company_plz_city || ''}
                    onChange={e => set('company_plz_city', e.target.value)}
                    placeholder="8620 Wetzikon"
                  />
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>Wird im QR-Einzahlungsschein verwendet</div>
                </div>
              </div>
            </div>

            {/* Trial & Plan */}
            <div className="card">
              <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 20 }}>
                Testphase & Preise
              </h3>
              <div className="grid-2" style={{ gap: 16 }}>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label">Testphase (Tage)</label>
                  <input
                    className="form-input"
                    type="number"
                    min={1}
                    max={90}
                    value={settings.trial_days || 30}
                    onChange={e => set('trial_days', e.target.value)}
                  />
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>Kostenlose Testphase für neue Moscheen</div>
                </div>
                {Object.entries(PRICES).map(([key, m]) => (
                  <div key={key} className="form-group" style={{ margin: 0 }}>
                    <label className="form-label">{m.label}</label>
                    <input
                      className="form-input"
                      type="number"
                      min={0}
                      step={0.01}
                      value={settings[key] || ''}
                      onChange={e => set(key, e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Invoice */}
            <div className="card">
              <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 20 }}>
                Rechnungsvorlage
              </h3>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Fußzeile (Deutsch)</label>
                <textarea
                  className="form-textarea"
                  rows={3}
                  value={settings.invoice_footer_de || ''}
                  onChange={e => set('invoice_footer_de', e.target.value)}
                  placeholder="Vielen Dank für Ihr Vertrauen — Ilmify"
                />
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>Erscheint am Ende jeder PDF-Rechnung</div>
              </div>
            </div>

            <CategoriesManager />

            <div style={{ display: 'flex', gap: 12 }}>
              <button className="btn btn-primary btn-lg" onClick={save} disabled={saving}>
                {saving ? 'Speichern...' : 'Einstellungen speichern'}
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
